import { useState, useEffect } from "react";
import { usePhoneAccount } from "../contexts/PhoneAccountContext";

/**
 * Custom hook for managing template state
 */
export const useTemplateState = (initialData = null) => {
  const { selectedPhoneAccount } = usePhoneAccount();
  
  const [templateData, setTemplateData] = useState({
    name: "",
    category: "UTILITY",
    language: "en_US",
    components: [
      {
        type: "BODY",
        text: "",
        example: null,
      },
    ],
    wabaId: "",
    phoneId: "",
    headerFile: null,
    headerFilePreview: null,
    header_media_url: null,
    variables: [],
  });

  // Update WABA account from context when it changes
  useEffect(() => {
    if (selectedPhoneAccount) {
      setTemplateData((prev) => ({
        ...prev,
        wabaId: selectedPhoneAccount.wabaId,
        phoneId: selectedPhoneAccount.phoneId,
      }));
    }
  }, [selectedPhoneAccount]);

  // Helper functions to work with components
  const getComponent = (type) => {
    return templateData.components.find((c) => c.type === type) || null;
  };

  const updateComponent = (type, updates) => {
    setTemplateData((prev) => {
      const components = [...prev.components];
      const index = components.findIndex((c) => c.type === type);

      if (index >= 0) {
        components[index] = { ...components[index], ...updates };
      } else {
        components.push({ type, ...updates });
      }

      return { ...prev, components };
    });
  };

  const removeComponent = (type) => {
    setTemplateData((prev) => ({
      ...prev,
      components: prev.components.filter((c) => c.type !== type),
    }));
  };

  // Convenience getters
  const getHeaderFormat = () => {
    const header = getComponent("HEADER");
    return header?.format || "NONE";
  };

  const getHeaderText = () => {
    const header = getComponent("HEADER");
    return header?.text || "";
  };

  const getBody = () => {
    const body = getComponent("BODY");
    return body?.text || "";
  };

  const getFooter = () => {
    const footer = getComponent("FOOTER");
    return footer?.text || "";
  };

  const getButtons = () => {
    const buttons = getComponent("BUTTONS");
    return buttons?.buttons || [];
  };

  return {
    templateData,
    setTemplateData,
    getComponent,
    updateComponent,
    removeComponent,
    getHeaderFormat,
    getHeaderText,
    getBody,
    getFooter,
    getButtons,
  };
};

